export const APP_ROOT = '/';

export const ROUTES = {
    LOGIN: `${APP_ROOT}`,
    HOME: `${APP_ROOT}home`,
    JOB: `${APP_ROOT}job`,
    EMPLOYEE: `${APP_ROOT}employee`,
    JOBDETAILINFO: `${APP_ROOT}jobdetail`,
    FORGOTPASSWORD: `${APP_ROOT}forgotpassword`,
    ADMIN: `${APP_ROOT}admin`,
    VOUCHERS: `${APP_ROOT}vouchers`,
    PAYMENT: `${APP_ROOT}payment`,
    JOBCHARGE: `${APP_ROOT}job-charges`,
    ROLES: `${APP_ROOT}roles`,
    PERMISSIONS: `${APP_ROOT}permissions`,
    ROLEPERMISSIONS: `${APP_ROOT}role-permissions`,
    TASK: `${APP_ROOT}tasks`,
    TASKPROGRESSNOTE: `${APP_ROOT}tasks-progress-note`,
};
